import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "./Sidebar";
import Header from "./Header";
import FloatingButton from "../features/Ticket/FloatingButton";

const AppLayout = ({ logout }) => {
  const [isMessageListOpen, setIsMessageListOpen] = useState(false);

  return (
    <div className="app-layout">
      <Header logout={logout} setIsMessageListOpen={setIsMessageListOpen} />

      <div className="content">
        <SideBar />
        <div className="main-content ">
          <Outlet />
        </div>
        <FloatingButton
          isMessageListOpen={isMessageListOpen}
          setIsMessageListOpen={setIsMessageListOpen}
        />
      </div>
    </div>
  );
};

export default AppLayout;
